exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".checkbox input[type='checkbox'].delete-manifest-options-input-cascading {\n  margin-left: 0;\n}\n.delete-manifest-options-input-grace-period {\n  display: inline-block;\n  margin-right: 5px;\n  max-width: 75px;\n}\n", ""]);

